
webpack.register(
    'modules/exemptions/exemptions-by-player/exemptions-by-player',
    function() {
        return import('modules/exemptions/exemptions-by-player/exemptions-by-player');
    },
    true
);